import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

const useStyles = makeStyles(theme => ({
  icon: {
    fill: '#fff',
    width: theme.spacing(5),
    height: theme.spacing(5)
  }
  }));
export default () => {
  const classes = useStyles();
  return (
    <Grid container direction="row" justify="flex-start" spacing={1}>
      <Grid item><a href="https://www.facebook.com/AusInstSuperTrustees" target="_blank" rel="noopener noreferrer"><FacebookIcon className={classes.icon} /></a></Grid>
      <Grid item><a href="https://twitter.com/aistbuzz" target="_blank" rel="noopener noreferrer"><TwitterIcon className={classes.icon} /></a></Grid>
      <Grid item><a href="https://www.youtube.com/channel/UCqe-WNo74im8e_dt7bGE6Og/channels" target="_blank" rel="noopener noreferrer"><YouTubeIcon className={classes.icon} /></a></Grid>
      <Grid item><a href="https://www.instagram.com/aist_super/" target="_blank" rel="noopener noreferrer"><InstagramIcon className={classes.icon} /></a></Grid>
      <Grid item><a href="https://www.linkedin.com/company/australian-institute-of-superannuation-trustees/" target="_blank" rel="noopener noreferrer"><LinkedInIcon className={classes.icon} /></a></Grid>
    </Grid>
  );
}
